// Use DEV_ vars when: running in dev (NODE_ENV) OR when explicitly set (e.g. Vercel Preview).
// Vercel always builds with NODE_ENV=production, so for "dev" deployments set REACT_APP_SUPABASE_ENV=development.
const useDevSupabase =
  process.env.NODE_ENV !== 'production' ||
  process.env.REACT_APP_SUPABASE_ENV === 'development';

const supabaseUrl = useDevSupabase
  ? process.env.REACT_APP_DEV_SUPABASE_URL || process.env.REACT_APP_SUPABASE_URL
  : process.env.REACT_APP_PROD_SUPABASE_URL || process.env.REACT_APP_SUPABASE_URL;

const supabaseAnonKey = useDevSupabase
  ? process.env.REACT_APP_DEV_SUPABASE_ANON_KEY || process.env.REACT_APP_SUPABASE_ANON_KEY
  : process.env.REACT_APP_PROD_SUPABASE_ANON_KEY || process.env.REACT_APP_SUPABASE_ANON_KEY;

export { supabaseUrl, supabaseAnonKey };

